import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { "max-width": "680px", persistent: "" },
      model: {
        value: _vm.dialogProps.visibilidade,
        callback: function ($$v) {
          _vm.$set(_vm.dialogProps, "visibilidade", $$v)
        },
        expression: "dialogProps.visibilidade",
      },
    },
    [
      _c(
        VCard,
        { staticClass: "pa-5" },
        [
          _c(
            VCardTitle,
            [
              _c(
                VRow,
                { staticClass: "d-flex flex-column text-lg-center" },
                [
                  _c(
                    "h4",
                    { staticClass: "headline primary--text text-no-wrap" },
                    [_vm._v(" " + _vm._s(_vm.labelBtnAcao) + " Escolaridade ")]
                  ),
                  _c("span", { staticClass: "subtitle-1" }, [
                    _vm._v("Informe seus dados de escolaridade"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            VCardText,
            [
              _c(
                VForm,
                {
                  ref: "form",
                  model: {
                    value: _vm.dialogProps.valid,
                    callback: function ($$v) {
                      _vm.$set(_vm.dialogProps, "valid", $$v)
                    },
                    expression: "dialogProps.valid",
                  },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.niveisEscolaridade,
                              rules: [(v) => !!v || "seleção obrigatória"],
                              "item-text": "descricao",
                              label: "Nível de Escolaridade",
                              "prepend-icon": "menu_book",
                              required: "",
                              "return-object": "",
                            },
                            model: {
                              value: _vm.escolaridade.nivelEscolaridade,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.escolaridade,
                                  "nivelEscolaridade",
                                  $$v
                                )
                              },
                              expression: "escolaridade.nivelEscolaridade",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.deveInformarNomeCurso || _vm.deveEscolherCurso
                    ? _c(
                        VRow,
                        [
                          _vm.deveEscolherCurso
                            ? _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VAutocomplete, {
                                    attrs: {
                                      items: _vm.cursos,
                                      rules: [
                                        (v) => !!v || "Selecione um curso",
                                      ],
                                      "search-input": _vm.cursoSearch,
                                      "item-text": "nome",
                                      label: "Curso",
                                      placeholder: "Digite para pesquisar...",
                                      "persistent-hint": "",
                                      "prepend-icon": "school",
                                      required: "",
                                      "return-object": "",
                                    },
                                    on: {
                                      "update:searchInput": function ($event) {
                                        _vm.cursoSearch = $event
                                      },
                                      "update:search-input": function ($event) {
                                        _vm.cursoSearch = $event
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "no-data",
                                          fn: function () {
                                            return [
                                              _c(
                                                VListItem,
                                                [
                                                  _c(
                                                    VListItemContent,
                                                    [
                                                      _c(VListItemTitle, [
                                                        _vm._v(" O curso "),
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "secondary--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.cursoSearch
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " não foi encontrado. "
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2222989406
                                    ),
                                    model: {
                                      value: _vm.escolaridade.curso,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.escolaridade, "curso", $$v)
                                      },
                                      expression: "escolaridade.curso",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.deveInformarNomeCurso
                            ? _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      rules: _vm.ruleNotEmpty,
                                      label: "Nome do Curso",
                                      "prepend-icon": "school",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.escolaridade.nomeCursoOutro,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.escolaridade,
                                          "nomeCursoOutro",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "escolaridade.nomeCursoOutro",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    [
                      _vm.deveInformarResidenciaEm
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  rules: _vm.ruleNotEmpty,
                                  label: "Tipo de Residência Médica",
                                  "prepend-icon": "school",
                                  required: "",
                                },
                                model: {
                                  value: _vm.escolaridade.residenciaEm,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.escolaridade,
                                      "residenciaEm",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "escolaridade.residenciaEm",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              rules: _vm.ruleNotEmpty,
                              label: "Instituição",
                              "prepend-icon": "account_balance",
                              required: "",
                            },
                            model: {
                              value: _vm.escolaridade.instituicao,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.escolaridade,
                                  "instituicao",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "escolaridade.instituicao",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c("h4", [_vm._v("Situação do Curso")]),
                          _c(
                            VRadioGroup,
                            {
                              attrs: {
                                rules: [
                                  (v) => !!v || "Selecione o status do curso",
                                ],
                                required: "",
                                row: "",
                              },
                              model: {
                                value: _vm.escolaridade.status.id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.escolaridade.status, "id", $$v)
                                },
                                expression: "escolaridade.status.id",
                              },
                            },
                            _vm._l(_vm.statusEscolaridade, function (status) {
                              return _c(VRadio, {
                                key: status.id,
                                attrs: {
                                  label: status.descricao,
                                  value: status.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c("h4", [_vm._v("Período")]),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      tipo: "month",
                                      label: "Início",
                                      tooltip: "Data de início da escolaridade",
                                      "data-inicial": _vm.escolaridade.inicio,
                                      max: _vm.maxInicioEscolaridade,
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.escolaridade.inicio = value),
                                    },
                                  }),
                                ],
                                1
                              ),
                              !_vm.statusAndamentoEscolaridade
                                ? _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("app-date-select", {
                                        attrs: {
                                          tipo: "month",
                                          label:
                                            _vm.labelCampoTerminoEscolaridade,
                                          tooltip:
                                            "Data de término da escolaridade",
                                          "data-inicial":
                                            _vm.escolaridade.termino,
                                          min: _vm.minTerminoEscolaridade,
                                          max: _vm.maxTerminoEscolaridade,
                                          disabled:
                                            _vm.escolaridade.inicio === "",
                                        },
                                        on: {
                                          return: (value) =>
                                            (_vm.escolaridade.termino = value),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCardActions,
            [
              _c(
                VRow,
                { staticClass: "justify-end mr-4" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mr-2",
                      attrs: {
                        disabled: !_vm.dialogProps.valid,
                        color: "primary",
                      },
                      on: { click: _vm.doAcao },
                    },
                    [_vm._v(" " + _vm._s(_vm.labelBtnAcao) + " ")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogProps.visibilidade = false
                        },
                      },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }